<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="remove-company-tags-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Remove Company Tags
                        </h4>
                    </div>

                    <div class="modal-body">
                        <TagsFormGroup
                            v-model="tags"
                            name="tags"
                            label="Tags"
                        />
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TagsFormGroup from '@/components/FormGroups/Block/Tags'

export default {
    components: {TagsFormGroup},

    mixins: [Errors],

    props: {
        selected: {
            type: Array
        }
    },

    data() {
        return {
            tags: []
        }
    },

    mounted() {
        this.listenForClose()
    },

    methods: {
        listenForClose() {
            $(this.$el).on('hidden.bs.modal', this.reset)
        },

        submit() {
            Promise
                .all(this.selected.map(company => http.put('/api/v2/companies/' + company.id, {
                    ...company.attributes,
                    tags: company.attributes.tags.filter(tag => !this.tags.map(tag => tag.text).includes(tag.name))
                })))
                .then(responses => {
                    notify.success('The tags were removed')

                    responses.map(response => this.$emit('updated', response.data.data))

                    $(this.$el).modal('hide')
                })
        },

        reset() {
            this.errors = {}

            this.tags = []
        }
    }
}
</script>
